import React from "react";
import { Text, ProcedureBloc } from "../../../../components";
import {
  TitleContainer,
  SubTitleContainer,
  OrientationContainer,
  ConfirmationBlocContainer,
} from "./styled-components";
import { useNavigate } from "react-router-dom";
import ConfirmationBloc from "../../../../components/confirmationBloc";

const ProcedureResponse = ({ params }: PreProcedureProps) => {
  const navigate = useNavigate();

  return (
    <>
      <TitleContainer>
        <Text size="40px" weight={700} lineHeight="52px" align="center">
          Le Défenseur des droits semble pouvoir vous aider. Mais vous devez{" "}
          <span>d'abord faire des démarches</span>.
        </Text>
      </TitleContainer>
      <SubTitleContainer>
        <Text size="18px" align="center" color="grey400">
          Votre situation semble correspondre aux domaines de compétence du
          Défenseur des Droits. Cependant vous devez d’abord effectuer des
          démarches préalables.
        </Text>
      </SubTitleContainer>
      <OrientationContainer>
        <ProcedureBloc />
      </OrientationContainer>
      <ConfirmationBlocContainer>
        <ConfirmationBloc
          onClick={() =>
            navigate(`/${params.domain}/${params?.exemple?.toLowerCase()}`)
          }
        />
      </ConfirmationBlocContainer>
    </>
  );
};

export default ProcedureResponse;
